// Generated by GitHub Copilot
import React, { useState, useRef, useCallback } from 'react';
import Navbar from '../layout/Navbar';
import styles from './Home.module.css';
import { GCC_API_BASE_URL } from '../../runtimeConfig';
import { CMD_CENTER_STORAGE_KEY } from '../../constants/cmdCenter';
import JourneyCard from '../common/JourneyCard';
import LeaderCard from '../common/LeaderCard';
import Footer from '../layout/Footer';
import thumbnailImg from '../../assets/images/homepageThumbnail.png';
import arundhatiImg from '../../assets/images/Photo Portrait (1).png';
import paulImg from '../../assets/images/Photo Portrait-1.png';
import sundeepImg from '../../assets/images/Photo Portrait-2.png';
import larryImg from '../../assets/images/Photo Portrait-3.png';
import groImg from '../../assets/images/Photo Portrait-4.png';
import pradeepImg from '../../assets/images/Photo Portrait-5.png';
import allanImg from '../../assets/images/Photo Portrait-6.png';

// Flat 4-card journey grid — rendered as 2 columns (left = No GCC, right = Existing GCC)
const JOURNEY_CARDS = [
  {
    badge: 'Client Has No GCC',
    title: "Growth and Cost Pressures tell us our Operating Model isn't working",
    description:
      "We're under pressure but haven't landed on a solution. We need to understand whether a GCC is the right answer — and need the case made to consider it.",
    links: ['Industry Origination', 'GCC Stage 0', 'Industry Narrative'],
    offeringSlug: 'exploring-gccs',
  },
  {
    badge: 'Client Has Existing GCC',
    title: 'Our GCC is running — but we know it could do more',
    description:
      "Whether costs have crept up or our ambition has grown, we're not getting full value from the model. We need a clear view of what's possible and a credible path to get there.",
    links: ['GCC Reinvention Playbook', 'GCC Maturity Diagnostic', 'GCC Platform'],
    offeringSlug: 'scale-expansion',
  },
  {
    badge: 'Client Has No GCC',
    title: 'We want to set up a GCC — and get it right from the start',
    description:
      "We've decided to build. Now we need help defining the strategy, choosing the right location and designing the operating model.",
    links: ['Design Playbook', 'Setup Playbook', 'ANSR Partnership'],
    offeringSlug: 'setup-and-launch',
  },
  {
    badge: 'Client Has Existing GCC',
    title: 'We want more from our GCC — more Functions, more AI, more Value',
    description:
      'The foundation is solid. We want to move into higher-value work, expand functions, or embed AI at scale — and we need a partner to help us get there fast.',
    links: ['GCC Maturity Diagnostic', 'AI for GCC', 'GCC Reinvention Playbook'],
    offeringSlug: 'value-and-ai-readiness',
  },
];

// Placeholder headshots — swap src values for real images
const LEADERS_ROW1 = [
  {
    name: 'Arundhati Chakraborty',
    role: 'GCC Lead',
    imgSrc: arundhatiImg,
    imgAlt: 'Portrait of Arundhati Chakraborty, GCC Lead',
    url:'https://wd103.myworkday.com/accenture/d/inst/1$247/247$1023906.htmld#TABTASKID=2998%2440311'
  },
  {
    name: 'Paul Jeruchimowitz',
    role: 'Global Practice Lead',
    imgSrc: paulImg,
    imgAlt: 'Portrait of Paul Jeruchimowitz, Global Practice Lead',
    url:'https://wd103.myworkday.com/accenture/d/inst/1$247/247$868535.htmld#TABTASKID=2998%2440311'
  },
  {
    name: 'Sundeep Gandhi',
    role: 'Global Sales Lead',
    imgSrc: sundeepImg,
    imgAlt: 'Portrait of Sundeep Gandhi, Global Sales Lead',
    url:'https://wd103.myworkday.com/accenture/d/inst/1$247/247$973583.htmld#TABTASKID=2998%2440311'
  },
];

const LEADERS_ROW2 = [
  {
    name: 'Larry Thomas',
    role: 'Americas GTM Lead',
    imgSrc: larryImg,
    imgAlt: 'Portrait of Larry Thomas, Americas GTM Lead',
    url:'https://wd103.myworkday.com/accenture/d/inst/1$247/247$883953.htmld#TABTASKID=2998%2440311'
  },
  {
    name: 'Gro Blindheim',
    role: 'EMEA GTM Lead',
    imgSrc: groImg,
    imgAlt: 'Portrait of Gro Blindheim, EMEA GTM Lead',
    url:'https://wd103.myworkday.com/accenture/d/inst/1$247/247$960680.htmld#TABTASKID=2998%2440311'
  },
  {
    name: 'Pradeep Prabhala',
    role: 'India GTM Lead',
    imgSrc: pradeepImg,
    imgAlt: 'Portrait of Pradeep Prabhala, India GTM Lead',
    url:'https://wd103.myworkday.com/accenture/d/inst/1$247/247$2813928.htmld#TABTASKID=2998%2440311'
  },
  {
    name: 'Allan Caballero',
    role: 'Philippines GTM Lead',
    imgSrc: allanImg,
    imgAlt: 'Portrait of Allan Caballero, Philippines GTM Lead',
    url:'https://wd103.myworkday.com/accenture/d/inst/1$247/247$752750.htmld?q=Alan+Caballero&state=searchCategory-all%3Adefault#TABTASKID=2998%2440311'
  },
];

// Generated by GitHub Copilot
const FAQ_ITEMS = [
  {
    category: 'Exploring GCCs',
    question: 'What is a GCC, and how do we know if it fits our talent strategy?',
    answer:
      'Start with the value case: talent access, cost-to-value, control, resilience and innovation. If the client has not considered a GCC yet, route to GCC Strategy & Design and industry origination assets.',
  },
  {
    category: 'Ready to setup',
    question: 'We have decided to build — where should we locate and what model should we use?',
    answer:
      'Confirm scope, operating model, location, governance, legal/entity needs and Day-1 KPIs. Compare Assisted Build, BOTT/JV and ANSR partnership paths before mobilization.',
  },
  {
    category: 'Setup in motion',
    question: 'Our GCC setup has started. How do we accelerate launch and stabilize Day-1?',
    answer:
      'Identify blockers across entity, facilities, hiring, transition, technology, change and adoption. Use setup acceleration, talent placement and platform-led transition governance.',
  },
  {
    category: 'Scale & capability expansion',
    question: 'Our GCC is running, but limited. How do we move beyond transactional work?',
    answer:
      'Run a maturity diagnostic, map capability gaps and shift higher-value work into talent-rich locations. Prioritize functional depth, engineering, data, cloud and product ownership.',
  },
  {
    category: 'Value & AI readiness',
    question: 'How do we prove ROI and scale AI safely inside the GCC?',
    answer:
      'Define value pools, modernize data/platform foundations, sequence AI use cases, embed Responsible AI controls and upskill the workforce through GCC reinvention and AI-for-GCC assets.',
  },
  {
    category: 'Talent augmentation',
    question: 'Can we access scarce skills fast without committing to permanent hiring?',
    answer:
      'Use on-demand talent pods or managed GCC teams for project spikes and niche skills. Clarify critical roles, duration, ramp curve, governance and whether a transfer path is needed.',
  },
];

/**
 * Home page for GCC Studio.
 * Contains the hero section, GCC journey selector, FAQ accordion, leadership team and footer.
 */
const VIDEO_SRC = '/videos/GCC_homepage_Video.mp4';

const Home = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const [showHeroCommand, setShowHeroCommand] = useState(false);

  // GCC Command Centre V2 state
  const [websiteInputV2, setWebsiteInputV2] = useState('');
  const [isGccV2Loading, setIsGccV2Loading] = useState(false);
  const [gccV2Status, setGccV2Status] = useState(null);

  // GCC Command Centre V3 state
  const [websiteInputV3, setWebsiteInputV3] = useState('');
  const [isGccV3Loading, setIsGccV3Loading] = useState(false);
  const [gccV3Status, setGccV3Status] = useState(null);

  const handleGccCommandCentreV2 = useCallback(async (e) => {
    e.preventDefault();
    const website = websiteInputV2.trim();
    if (!website || isGccV2Loading) return;

    setIsGccV2Loading(true);
    setGccV2Status(null);

    const command = `Build a GCC dashboard, website: ${website}`;

    try {
      // 1. POST to /gcc-command-centre-v2 → get dashboardData JSON
      const res = await fetch(`${GCC_API_BASE_URL}/gcc-command-centre-v2`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ command }),
      });

      if (!res.ok) throw new Error(`Server error: ${res.status}`);

      const data = await res.json();

      if (!data.isValid || data.didError || !data.dashboardData) {
        setGccV2Status({ type: 'error', message: 'The command returned no valid data. Please refine your query.' });
        return;
      }

      // 2. Fetch the static template
      const tplRes = await fetch('/gcc_command_centre_template.html');
      if (!tplRes.ok) throw new Error(`Template fetch failed: ${tplRes.status}`);
      const templateHtml = await tplRes.text();

      // 3. Inject data — replace the null placeholder with real data, and set the tab title
      const companyName = data.dashboardData?.company?.name ?? website;
      const injected = templateHtml
        .replace(
          'window.__GCC_DASHBOARD_DATA__ = null;',
          `window.__GCC_DASHBOARD_DATA__ = ${JSON.stringify(data.dashboardData)};`
        )
        .replace(
          /(<title>)[^<]*(<\/title>)/,
          `$1${companyName} — Command Centre$2`
        );

      // 4. Open in new tab — same pattern as existing /gcc-command-centre
      const blob = new Blob([injected], { type: 'text/html' });
      window.open(URL.createObjectURL(blob), '_blank', 'noopener,noreferrer');
      setWebsiteInputV2('');
      setGccV2Status(null);
    } catch (err) {
      setGccV2Status({ type: 'error', message: err.message || 'Failed to reach the GCC Command Centre V2 API.' });
    } finally {
      setIsGccV2Loading(false);
    }
  }, [websiteInputV2, isGccV2Loading]);

  const handleGccCommandCentreV3 = useCallback(async (e) => {
    e.preventDefault();
    const website = websiteInputV3.trim();
    if (!website || isGccV3Loading) return;

    setIsGccV3Loading(true);
    setGccV3Status(null);

    try {
      const res = await fetch(`${GCC_API_BASE_URL}/gcc-command-centre-v3`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ command: website }),
      });

      if (!res.ok) throw new Error(`Server error: ${res.status}`);

      const data = await res.json();

      if (!data.isValid || data.didError || !data.dashboardData) {
        setGccV3Status({ type: 'error', message: 'The command returned no valid data. Please refine your query.' });
        return;
      }

      // Hand the response to the /cmdcenter React page (native dashboard — no HTML template).
      try {
        localStorage.setItem(CMD_CENTER_STORAGE_KEY, JSON.stringify({ command: website, response: data }));
      } catch (storageErr) {
        setGccV3Status({ type: 'error', message: 'Could not prepare the Command Center (browser storage is full or blocked). Please try again.' });
        return;
      }
      const tab = window.open('/cmdcenter', '_blank');
      if (!tab) {
        setGccV3Status({ type: 'error', message: 'Pop-up blocked. Please allow pop-ups for this site and try again.' });
        return;
      }
      setWebsiteInputV3('');
      setGccV3Status({ type: 'success', message: 'The Command Center has been successfully created and opened in a new tab.' });
    } catch (err) {
      setGccV3Status({ type: 'error', message: err.message || 'Failed to reach the GCC Command Centre V3 API.' });
    } finally {
      setIsGccV3Loading(false);
    }
  }, [websiteInputV3, isGccV3Loading]);

  /**
   * Toggles the FAQ accordion item at the given index.
   * Collapses the item if it is already open (single-open behaviour).
   * @param {number} index - The index of the FAQ item to toggle.
   */
  const handleFaqToggle = (index) => {
    setOpenFaqIndex((prev) => (prev === index ? null : index));
  };

  /**
   * Reveals the video element and starts playback.
   * Hides the thumbnail overlay to free memory from the img element.
   */
  const handlePlay = () => {
    setIsPlaying(true);
    // Defer play until after re-render mounts the video element
    setTimeout(() => videoRef.current?.play(), 0);
  };

  return (
    <div className={styles.page}>
      <Navbar />
      <div className={styles.heroPadding} />

      {/* ── Hero Section ── */}
      <section
        className={styles.heroSection}
        aria-labelledby="hero-heading"
      >
        {/* ── Bokeh background blobs matching reference ── */}
        <div aria-hidden="true" className={styles.bokehContainer}>
          {/* Large left bloom */}
          <div className={styles.blobLeftLarge} />
          {/* Mid-left lower */}
          <div className={styles.blobMidLeft} />
          {/* Center top */}
          <div className={styles.blobCenterTop} />
          {/* Center bloom */}
          <div className={styles.blobCenter} />
          {/* Right bloom */}
          <div className={styles.blobRight} />
          {/* Far right lower */}
          <div className={styles.blobFarRight} />
        </div>

        {/* Content row */}
        <div className={styles.heroContent}
             style={{ maxWidth: 'min(1160px, 95vw)' }}>

          {/* Left — 40% — text */}
          <div className={styles.heroText}>
            <h1
              id="hero-heading"
              className={styles.heroHeading}
            >
              <span className={styles.heroHeadingLight}>
                Welcome to
              </span>
              <span className={styles.heroHeadingBold}>
                GCC Studio
              </span>
            </h1>
            <p className={styles.heroSubtext}>
              Walk into every GCC Conversation with Clarity, Confidence and a Point of View—ready to unlock Scale, Accelerate Innovation and Drive Measurable Impact.
            </p>
            <a href="/gcc-origination-engine.html" target="_blank" rel="noopener noreferrer" className={styles.sectionLabel} style={{ textDecoration: 'underline', cursor: 'pointer', color: '#ffffff' }}>Explore your industry and client now</a>
            <br/> <br/>
            <a href="https://teams.microsoft.com/l/entity/683f3525-d193-4a67-8d91-22093beab1ca?context=%7B%22contextType%22%3A%22engageCommunity%22%2C%22internalId%22%3A%2219%3AeyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIyMTA0NzU8ODA1MDYxNjMyIn0%40EngageCommunity%22%2C%22subEntityId%22%3A%22%7B%5C%22deepLinkType%5C%22%3A%5C%22crossapp%5C%22%2C%5C%22path%5C%22%3A%5C%22groups%2FeyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIyMTA0NzU8ODA1MDYxNjMyIn0%2Fall%5C%22%2C%5C%22communityId%5C%22%3A%5C%2219%3AeyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIyMTA0NzU8ODA1MDYxNjMyIn0%40EngageCommunity%5C%22%7D%22%7D" target="_blank" rel="noopener noreferrer" className={styles.sectionLabel} style={{ textDecoration: 'underline', cursor: 'pointer', color: '#ffffff' }}>Join our community</a>
            <br/><br/>
            {/* ── Hero Command Input ── */}
            <div className={styles.heroCommandArea}>
              {/* <button
                type="button"
                className={styles.sectionLabel}
                style={{ textDecoration: 'underline', cursor: 'pointer', color: '#ffffff', background: 'none', border: 'none', padding: 0, font: 'inherit' }}
                onClick={() => setShowHeroCommand((v) => !v)}
              >
                Create a Command Center View
              </button> */}

              {showHeroCommand && (
                <>
                  {/* <form onSubmit={handleGccCommandCentreV2} className={styles.heroCommandRow}>
                    <input
                      type="text"
                      value={websiteInputV2}
                      onChange={(e) => setWebsiteInputV2(e.target.value)}
                      placeholder="Input your Client's name"
                      className={styles.heroCommandInput}
                      disabled={isGccV2Loading}
                      aria-label="GCC Command Centre V2 input"
                      autoFocus
                    />
                    <button
                      type="submit"
                      className={styles.heroCommandBtn}
                      disabled={isGccV2Loading || !websiteInputV2.trim()}
                    >
                      {isGccV2Loading ? (
                        <svg className={styles.heroCommandSpinner} viewBox="0 0 24 24" fill="none" aria-hidden="true">
                          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="31.4 31.4" />
                        </svg>
                      ) : 'Generate →'}
                    </button>
                  </form>
                  {gccV2Status && (
                    <p className={`${styles.heroCommandStatus} ${gccV2Status.type === 'error' ? styles.commandStatusError : styles.commandStatusSuccess}`}>
                      {gccV2Status.message}
                    </p>
                  )} */}

                  {/* <form onSubmit={handleGccCommandCentreV3} className={styles.heroCommandRow}>
                    <input
                      type="text"
                      value={websiteInputV3}
                      onChange={(e) => setWebsiteInputV3(e.target.value)}
                      placeholder="Input your Client's name"
                      className={styles.heroCommandInput}
                      disabled={isGccV3Loading}
                      aria-label="GCC Command Centre V3 input"
                    />
                    <button
                      type="submit"
                      className={styles.heroCommandBtn}
                      disabled={isGccV3Loading || !websiteInputV3.trim()}
                    >
                      {isGccV3Loading ? (
                        <svg className={styles.heroCommandSpinner} viewBox="0 0 24 24" fill="none" aria-hidden="true">
                          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="31.4 31.4" />
                        </svg>
                      ) : 'Generate →'}
                    </button>
                  </form> */}
                  {/* {gccV3Status && (
                    <p className={`${styles.heroCommandStatus} ${gccV3Status.type === 'error' ? styles.commandStatusError : styles.commandStatusSuccess}`}>
                      {gccV3Status.message}
                    </p>
                  )} */}
                </>
              )}
            </div>
          </div>

          {/* Right — 60% — video */}
          <div className={styles.heroVideoCol}>
            <div
              className={styles.videoWrapper}
              style={{ aspectRatio: '16 / 9' }}
            >
              {/* ── Video element — hidden until play is triggered ── */}
              {isPlaying && (
                <video
                  ref={videoRef}
                  className={styles.videoThumbnail}
                  controls
                  preload="metadata"
                  aria-label="GCC Convergence Chicago introduction video"
                >
                  <source src={VIDEO_SRC} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}

              {/* ── Thumbnail + centered play button overlay ── */}
              {!isPlaying && (
                <>
                  <img
                    src={thumbnailImg}
                    alt="GCC Convergence event preview"
                    className={styles.videoThumbnail}
                  />
                  <div
                    className={styles.videoGradient}
                    aria-hidden="true"
                  />
                  <button
                    type="button"
                    className={styles.videoLink}
                    aria-label="Play GCC Convergence Chicago introduction video"
                    onClick={handlePlay}
                  >
                    <div
                      className={styles.playButton}
                      aria-hidden="true"
                    >
                      <svg className={styles.playIcon} fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                  </button>
                </>
              )}
            </div>
          </div>

        </div>
      </section>

      {/* Divider */}
      <div className={styles.divider} aria-hidden="true" />

      {/* ── Journey Selector Section ── */}
      <section
        className={styles.journeySection}
        aria-labelledby="journey-heading"
      >
        <h2
          id="journey-heading"
          className={styles.sectionHeadingNormal}
        >
          What is your client trying to{' '}
          <span className={styles.headingAccent}>solve?</span>
        </h2>
        <p className={styles.sectionSubtext}>
          Select where your organization is in its GCC journey to view the most
          relevant support options
        </p>

        {/* Flat 2-column grid — left column: No GCC, right column: Existing GCC */}
        <div
          className={styles.journeyGrid}
          style={{ maxWidth: 'min(1160px, 95vw)' }}
        >
          {JOURNEY_CARDS.map((card) => (
            <JourneyCard key={card.title} {...card} />
          ))}
        </div>
      </section>

      {/* Divider */}
      <div className={styles.divider} aria-hidden="true" />

      {/* ── Leadership Team Section ── */}
      <section
        className={styles.leadershipSection}
        aria-labelledby="leadership-heading"
      >
        <h2
          id="leadership-heading"
          className={styles.sectionHeadingBold}
        >
          GCC Leadership Team
        </h2>
        <p className={styles.sectionSubtext}>
          Start here to activate a GCC in your account by reaching out to the right leader for
          guidance, context and support
        </p>

        <div className={styles.leadersContainer} style={{maxWidth: 'min(1160px, 95vw)'}}>
          {/* Row 1 — 3 cards, centered */}
          <div className={styles.leadersRow1}>
            {LEADERS_ROW1.map((leader) => (
              <div key={leader.name} className={styles.leaderCardRow1}>
                <LeaderCard {...leader} />
              </div>
            ))}
          </div>

          {/* Row 2 — 4 cards */}
          <div className={styles.leadersRow2}>
            {LEADERS_ROW2.map((leader) => (
              <div key={leader.name} className={styles.leaderCardRow2}>
                <LeaderCard {...leader} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;
